<template>
  <div class="grid grid-rows my-4 order-history overflow-x-auto">
    <div class="md:flex md:items-center md:justify-between">
      <div class="min-w-0 flex mb-2">
        <h2 class="text-2xl font-bold text-gray-900 sm:truncate sm:tracking-tight">Bestellingen</h2>
      </div>
    </div>
    <div class="">
      <div class="grid grid-rows my-2" v-if="ordersByCustomFilter.length === 0">
        <Alert
          :html="true"
          htmlMessage="Er zijn geen bestellingen geplaatst binnen uw instelling of de patiënt wenst geen gegevens te delen."
          type="info"
        ></Alert>
      </div>
      <tables v-else class="overflow-hidden rounded-lg">
        <template #tableHeaders>
          <thead>
            <tr class="bg-sky-50 border-x border-t border-balternative-color">
              <th
                scope="col"
                class="py-3.5 pl-4 pr-3 text-left text-base font-bold text-pdsPrimaryColor"
                v-for="header in orderHeader"
                :key="header"
              >
                {{ header }}
              </th>
            </tr>
          </thead>
        </template>
        <template #tableBody>
          <tbody class="bg-white">
            <v-order-history-entry
              v-for="(item, index) in ordersByCustomFilter"
              :key="index"
              :index="index"
              :entry="item"
            >
              <template v-slot:details>
                <v-order-history-entry-products
                  v-if="item.customerOrderLines && item.customerOrderLines.length > 0"
                  :order="item"
                  :show-re-order="isActiveLicense"
                  :patient-deceased-status="patientGegevens.IsDeceased"
                  :is-archived="isArchived"
                />
              </template>
            </v-order-history-entry>
          </tbody>
        </template>
      </tables>
      <!--Show More/Less Functionality -->
      <button
        v-if="orderHistory.length + (repeatOrderPlan ? repeatOrderPlan.length : 0) > filterCountDefault"
        @click.prevent="toggleFilterCount"
        class="flex justify-center py-2 px-2 md:px-4 border border-primary-default shadow-sm text-sm font-medium text-primary-default bg-white rounded-full hover:bg-primary-default/50 items-center my-4"
      >
        <template v-if="!filterCount">
          {{ filterCountButtonTextOptions.less }}
        </template>
        <template v-if="filterCount > 0">
          {{ filterCountButtonTextOptions.more }}&nbsp;
          <span v-if="orderHistory.length + (repeatOrderPlan ? repeatOrderPlan.length : 0) > filterCountDefault"
            >({{ orderHistory.length + (repeatOrderPlan ? repeatOrderPlan.length : 0) }})</span
          >
        </template>
      </button>
    </div>
  </div>
</template>

<script>
import router from '@/router';
import { mapActions, useStore } from 'vuex';
import { computed, onUnmounted } from 'vue';
import VOrderHistoryEntry from '@/components/sections/patient/orders/orderHistory/OrderHistoryEntry';
import VOrderHistoryEntryProducts from '@/components/sections/patient/orders/orderHistory/OrderHistoryEntryProducts';

export default {
  name: 'OrderHistory',
  components: {
    VOrderHistoryEntry,
    VOrderHistoryEntryProducts
  },
  props: {
    isActiveLicense: {
      default: false,
      type: Boolean
    },
    isArchived: {
      default: false,
      type: Boolean
    }
  },
  setup() {
    const store = useStore();

    const orderHistory = computed(() => store.getters['patientOrderHistory/getOrderHistory']);
    const repeatOrderPlan = computed(() => store.getters['patientOrderHistory/getRepeatOrderPlan']);
    const demoFlowStatus = computed(() => store.getters['navigation/getDemoFlowStatus']);
    const patientGegevens = computed(() => store.getters['patient/getPatientGegevens']);
    const resetOrderHistory = () => store.commit('patientOrderHistory/setOrderHistory', []);
    onUnmounted(() => {
      resetOrderHistory();
    });

    return {
      orderHistory,
      repeatOrderPlan,
      demoFlowStatus,
      patientGegevens,
      ...mapActions({
        getOrderHistory: 'patientOrderHistory/getOrderHistory',
        getRepeatOrderPlan: 'patientOrderHistory/getRepeatOrderPlan'
      })
    };
  },
  data() {
    return {
      orderHeader: ['Levering', 'Status', 'Ordernummer', 'Besteld door', 'Besteldatum', 'Adres', 'Type', ''],
      filterCountButtonTextOptions: {
        more: 'Toon meer',
        less: 'Toon minder'
      },
      filterCountDefault: 3,
      filterCount: null
    };
  },
  computed: {
    /**
     * @returns {array} - list with orders filtered by dynamic value of count and sliced by dynamic value of filtercount
     */
    ordersByCustomFilter() {
      // Combine order history and repeat order plan data
      const orderHistoryData = Array.isArray(this.orderHistory) ? this.orderHistory : [];
      const repeatOrderPlanData = Array.isArray(this.repeatOrderPlan) ? this.repeatOrderPlan : [];

      const combinedOrders = [...orderHistoryData, ...repeatOrderPlanData];

      if (combinedOrders.length > 0) {
        const sortedOrders = combinedOrders.sort((a, b) => {
          const dateA = new Date(a.deliveryDate || 0);
          const dateB = new Date(b.deliveryDate || 0);
          return dateB - dateA; // Descending order so that future planned orders are at the top
        });

        return this.filterCount ? sortedOrders.slice(0, this.filterCount) : sortedOrders;
      } else {
        return [];
      }
    }
  },
  created() {
    this.getOrderHistory();
    this.getRepeatOrderPlan();
    this.filterCount = this.filterCountDefault;
  },
  methods: {
    /**
     * @function toggleFilterCount
     * @desc Toggles the filter count between null and filterCountDefault
     */
    toggleFilterCount() {
      this.filterCount = this.filterCount ? null : this.filterCountDefault;
    },
    goToCatalog() {
      router.push('/catalog');
    }
  }
};
</script>
